import { fetchPicture, logout } from '@mobile-dev/platform/common/redux/actions/AmplifyUserAction'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, Redirect, useHistory } from 'react-router-dom'
import Jack_Icon from '../../assets/images/FreightSmith_JACKALOPE_ICON.png'
import NewBrandLogo from '../../assets/images/FreightSmith_WORDMARK_blue.png'
import { Context } from '../../Utils/Wrapper'
import Loader from '../Common/Loader'
import { isMobile } from 'react-device-detect';
import MobileLeftBar from '../Sidebar/MobileLeftBar';
import Settings from '../Sidebar/Settings';
import { injectIntl } from 'react-intl';

function Navbar({ intl, isDarkThemeActive, changeTheme }) {
    const ref = useRef();
    const dispatch = useDispatch();
    const [isMenuOpen, setIsMenuOpen] = useState(false)
    const user = useSelector(state => state.amplifyUser.user);
    const loggedInuser = useSelector(state => state.login.captchaResponse);
    const carrierLoggedIn = useSelector(state => state.carrierLogin);
    const history = useHistory();
    const [isMobileMenu, setIsMobileMenu] = useState(false);
    const { formatMessage } = intl;

    const handleMobileMenu = () => {
        setIsMobileMenu(true);
    }

    const closeMobileMenu = () => {
        setIsMobileMenu(false);
    }

    const context = useContext(Context);
    const [isSetting, setIsSetting] = useState(false);

    useEffect(() => {
        const checkIfClickedOutside = e => {
            // If the menu is open and the clicked target is not within the menu,
            // then close the menu
            if(document.querySelector('#react-joyride-portal')){
                return
            }
            if (ref.current && !ref.current.contains(e.target)) {
                document.getElementById("drop-down").classList.remove("show")
            }
        }
        document.addEventListener("mousedown", checkIfClickedOutside)

        return () => {
            // Cleanup the event listener
            document.removeEventListener("mousedown", checkIfClickedOutside)
            // document.getElementById("drop-down").classList.remove("show")
        }
    }, [isMenuOpen])

    useEffect(() => {
        if (user)
            dispatch(fetchPicture(user));
    }, [user]);

    if (!user) return <Loader />

    const userData = user.attributes;

    const HandleClickuser = () => {
        document.getElementById("drop-down").classList.contains("show") ? document.getElementById("drop-down").classList.remove("show") : document.getElementById("drop-down").classList.add("show")
        setIsMenuOpen(true)
    }


    const handleLogout = () => {
        dispatch(logout());
        history.push('/');
        return null;
    }

    const handleTheme = () => {
        changeTheme(!isDarkThemeActive);
    }

    const handleSettings = () => {
        setIsSetting(true);
        document.getElementById("drop-down").classList.remove("show");
        setIsMenuOpen(false);
    }

    const closeSettings = () => {
        setIsSetting(false);
    }


    if (!loggedInuser && !carrierLoggedIn) {
        return <Redirect to="/home" />
    }

    return (


        <div className="navbar-custom topnav-navbar topnav-navbar-dark" >
            <div className="container-fluid">
                <Link to="/" className="topnav-logo react_tour_step_2">
                    <span className="d-flex topnav-logo-lg text-warning tourLogo">
                        <img src={NewBrandLogo} alt="FrieghtSmith" height="40" className="img-wordmark" />
                    </span>
                    <span className="topnav-logo-sm text-warning tourLogo" style={{ fontSize: '1.5rem' }}>
                        <img src={Jack_Icon} alt="FrieghtSmith" height="50" />
                    </span>
                </Link>

                <ul className="list-unstyled topbar-right-menu float-right mb-0">
                    {isMobile &&
                        <li className=" dropdown notification-list">
                            <button className='btn-bg-none' onClick={handleMobileMenu}>
                                <i class="fal mobile-menu-icon fa-bars"></i>
                            </button>
                        </li>
                    }

                    <li className="dropdown notification-list react_tour_step_3">
                        <a className="nav-link dropdown-toggle nav-user arrow-none mr-0" data-toggle="dropdown"
                            id="topbar-userdrop" role="button" aria-haspopup="true" aria-expanded="false" onClick={() => HandleClickuser()} >
                            <span className="account-user-avatar">
                                <i className="fal fa-user-circle fa-2x"></i>
                            </span>
                            <span>
                                <span className="account-user-name">{userData?.given_name} {userData?.family_name}</span>
                            </span>
                        </a>

                        <div className="dropdown-menu dropdown-menu-right dropdown-menu-animated topbar-dropdown-menu profile-dropdown react_tour_step_4"
                            id="drop-down" aria-labelledby="topbar-userdrop" ref={ref}>
                            {isMenuOpen && (
                                <React.Fragment>
                                        <>
                                            <Link to='/profile' className="dropdown-item notify-item react_tour_step_5" onClick={() => HandleClickuser()}>
                                                <i className="fal fa-user mr-1"></i>
                                                <span>{formatMessage({ id: "app.my_account" })}</span>
                                            </Link>
                                            <div className="dropdown-divider mb-0"></div>
                                        </>
                                    <button className="dropdown-item notify-item react_tour_step_7" onClick={handleSettings}>
                                        <i className="fal fa-cog mr-1"></i>
                                        <span>{formatMessage({ id: "app.settings" })}</span>
                                    </button>
                                    <div className="dropdown-divider mb-0"></div>

                                    <button className="dropdown-item notify-item react_tour_step_6" onClick={handleLogout}>
                                        <i className="fal fa-sign-out mr-1"></i>
                                        <span>{formatMessage({ id: "app.logout" })}</span>
                                    </button>
                                </React.Fragment>
                            )}
                        </div>
                        {isSetting && <Settings
                            open
                            onButtonClick={closeSettings}
                            onThemeChange={handleTheme}
                        />}

                    </li>

                </ul>
            </div>
            {isMobileMenu &&
                <MobileLeftBar
                    open
                    onButtonClick={closeMobileMenu} />}
        </div>

    )
}

export default injectIntl(Navbar);
